import type { Variants } from 'motion/react';

const THUMBNAIL_REVEAL_EASING = [0.16, 1, 0.3, 1] as const;
const THUMBNAIL_EXIT_EASING = [0.4, 0, 0.2, 1] as const;

interface SpartanProductExteriorThreesixtyPresetMotion {
  background: Variants;
  group: Variants;
  item: Variants;
  list: Variants;
}

export const getSpartanProductExteriorThreesixtyPresetMotion = (
  shouldReduceMotion: boolean
): SpartanProductExteriorThreesixtyPresetMotion => {
  const staggerChildren = shouldReduceMotion ? 0 : 0.05;
  const itemOffset = shouldReduceMotion ? 0 : 12;

  return {
    background: {
      initial: { opacity: 0 },
      animate: {
        opacity: 1,
        transition: {
          duration: shouldReduceMotion ? 0.1 : 0.3,
          ease: THUMBNAIL_REVEAL_EASING,
        },
      },
    },
    group: {
      initial: { opacity: 1, y: 0 },
      animate: { opacity: 1, y: 0 },
      exit: {
        opacity: 0,
        y: shouldReduceMotion ? 0 : 8,
        transition: {
          duration: shouldReduceMotion ? 0.1 : 0.22,
          ease: THUMBNAIL_EXIT_EASING,
        },
      },
    },
    list: {
      initial: {},
      animate: {
        transition: { staggerChildren },
      },
    },
    item: {
      initial: { opacity: 0, x: itemOffset },
      animate: {
        opacity: 1,
        x: 0,
        transition: {
          duration: shouldReduceMotion ? 0.1 : 1,
          ease: THUMBNAIL_REVEAL_EASING,
        },
      },
    },
  };
};
